/**
 * Legacy v1 participant URLs: /GetStartedPage/{jwt}, /Survey/{jwt}, /Completed/{jwt}
 * v2 uses /a/{jwt}. Normalize tokens and redirect old paths.
 */

export const LEGACY_PARTICIPANT_PATH_RE =
  /^\/(getstartedpage|survey|completed)\/([^/]+)\/?$/i;

export function normalizeParticipantToken(raw) {
  if (raw == null || raw === "") return "";
  let token = String(raw).trim();
  if (!token) return "";
  try {
    if (/%[0-9A-Fa-f]{2}/.test(token)) {
      token = decodeURIComponent(token);
    }
  } catch {
    /* keep raw token */
  }
  // Some mail clients / proxies turn '+' into space in copied links.
  if (token.includes(" ") && token.includes(".")) {
    token = token.replace(/ /g, "+");
  }
  return token;
}

/** @returns {string|null} v2 path e.g. /a/{token}, or null if not a legacy participant URL */
export function legacyParticipantRedirectPath(pathname, search = "", hash = "") {
  const match = String(pathname || "").match(LEGACY_PARTICIPANT_PATH_RE);
  if (!match) return null;
  const token = normalizeParticipantToken(match[2]);
  if (!token) return null;
  return `/a/${token}${search || ""}${hash || ""}`;
}

/** Run once before React Router (dev server has no nginx rewrite). */
export function runLegacyParticipantRedirect() {
  if (typeof window === "undefined") return false;
  const target = legacyParticipantRedirectPath(
    window.location.pathname,
    window.location.search,
    window.location.hash
  );
  if (!target || target === `${window.location.pathname}${window.location.search}${window.location.hash}`) {
    return false;
  }
  window.location.replace(new URL(target, window.location.href).href);
  return true;
}
